import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, r1) {
  var result = Complex.createComplex(r1, 0).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c1, c2, r1, r2, rOut, sImaginary, sSquared) {
  var complexFFNumerator = Complex.createComplex(
    +rOut + sSquared * rOut * c1 * c2 * r1 * r2,
    sImaginary * rOut * (c1 * r1 + c2 * r2),
  );
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
